import type {ReactElement} from 'react';
import React from 'react';
import type {ListItemType3Storage, ListSubItemStorageType3} from '@Components/list/components/list-item-type-3';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './selected-type-pill.module.scss';

export interface SelectedTypePillProps {
  listItem: ListItemType3Storage;
  onClose: (e: any) => void;
}

function SelectedTypePill({listItem, ...props}: SelectedTypePillProps): ReactElement {
  const selectedItemOrientation: ListSubItemStorageType3 | undefined = listItem.subItems?.find((subitem) => {
    return subitem.isSelected === true;
  });

  return (
    <li key={listItem.id} className={`${styles.selectedTypeItemTextContainer} flex-row-align-center spacing-p-t-2 spacing-p-r-3 spacing-p-b-2 spacing-p-l-3 radius-4`}>
      <div className="flex-row-align-center spacing-m-r-3">
        <Text dangerouslySetInnerHTML={listItem.containsDangerouslySetText} className={`${styles.primary200}`} val={listItem.text} size={TextSize.XSMALL} bold />
        {selectedItemOrientation?.text ? <Text className={`${styles.primary200}`} val={`(${selectedItemOrientation?.text})`} size={TextSize.XXSMALL} bold /> : null}
      </div>
      <Icon data-id={`${listItem.id}`} className={`${styles.primary200} ${styles.selectedTypePillIcon}`} icon="icon-close" size={IconSize.SIZE_ICON_20} onClick={props.onClose} />
    </li>
  );
}

export default SelectedTypePill;
